import { render, staticRenderFns } from "./enable-notifications-prompt.vue?vue&type=template&id=013669dc&"
import script from "./enable-notifications-prompt.vue?vue&type=script&lang=js&"
export * from "./enable-notifications-prompt.vue?vue&type=script&lang=js&"
import style0 from "./enable-notifications-prompt.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports